import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import api_token_bridge_client_jGF4DmBOdm from "/app/plugins/api-token-bridge.client.ts";
import safe_area_init_client_QbI51lgnxB from "/app/plugins/safe-area-init.client.ts";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import restore_state_client_4oHW6JzpOW from "/app/node_modules/nuxt/dist/app/plugins/restore-state.client.js";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import plugin_vue3_A0OWXRrUgq from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_config_o34nk2sJbg from "/app/.nuxt/sentry-client-config.mjs";
import switch_locale_path_ssr_5csfIgkrBP from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_8SbxDRbG6Y from "/app/node_modules/dayjs-nuxt/dist/runtime/plugin.mjs";
import components_client_ZB1W0EeH0E from "/app/node_modules/nuxt-swiper/dist/runtime/plugins/components.client.js";
import slideovers_X7whXyrIWR from "/app/node_modules/@nuxt/ui/dist/runtime/plugins/slideovers.js";
import modals_oqljskDzoR from "/app/node_modules/@nuxt/ui/dist/runtime/plugins/modals.js";
import colors_ETtiVmZNmO from "/app/node_modules/@nuxt/ui/dist/runtime/plugins/colors.js";
import plugin_client_OVoKJro5pc from "/app/node_modules/@nuxtjs/color-mode/dist/runtime/plugin.client.js";
import plugin_WLsn00x1qh from "/app/node_modules/@nuxt/icon/dist/runtime/plugin.js";
import _00_consola_level_3CPy7oOpos from "/app/plugins/00.consola-level.ts";
import institution_ssr_af4mkUzYu2 from "/app/plugins/institution-ssr.ts";
import analytics_client_mtqVw3YRXk from "/app/plugins/analytics.client.ts";
import yandex_metrika_client_MiNHrQhx1f from "/app/plugins/yandex-metrika.client.ts";
import marketing_consent_sync_client_RIKEnW3W1z from "/app/plugins/marketing-consent-sync.client.ts";
import dev_unregister_stale_sw_client_mmEH7DCRd7 from "/app/plugins/dev-unregister-stale-sw.client.ts";
import apexcharts_client_Dd5Ebxj7XB from "/app/plugins/apexcharts.client.ts";
import app_update_check_client_g6RjdrySyU from "/app/plugins/app-update-check.client.ts";
import appearance_client_0OZbkuw8Ky from "/app/plugins/appearance.client.ts";
import authMonitor_client_ovA28D70BA from "/app/plugins/authMonitor.client.ts";
import capacitor_debug_client_9YsBul9OJo from "/app/plugins/capacitor-debug.client.ts";
import capawesome_update_check_client_ZkIndBIwXa from "/app/plugins/capawesome-update-check.client.ts";
import cart_migration_client_JUjvYfjpD3 from "/app/plugins/cart-migration.client.ts";
import debugTools_client_WuVt9iWWnH from "/app/plugins/debugTools.client.ts";
import deep_link_client_BddS0l8Itc from "/app/plugins/deep-link.client.ts";
import max_webapp_client_RA7MVAWi7C from "/app/plugins/max-webapp.client.ts";
import push_notifications_auth_init_client_0vmCY4EbxI from "/app/plugins/push-notifications-auth-init.client.ts";
import push_notifications_ios_client_8t7IWUWdTL from "/app/plugins/push-notifications-ios.client.ts";
import push_notifications_client_9sl3USyx58 from "/app/plugins/push-notifications.client.ts";
import queued_notification_action_bridge_client_jkpNBEhTzJ from "/app/plugins/queued-notification-action-bridge.client.ts";
import referral_token_client_OhXOx2Kolr from "/app/plugins/referral-token.client.ts";
import rustore_update_init_client_Ywypl0pXrI from "/app/plugins/rustore-update-init.client.ts";
import status_bar_client_VjO5ZxXl7f from "/app/plugins/status-bar.client.ts";
import system_back_handler_client_VDjvzyLqHp from "/app/plugins/system-back-handler.client.ts";
import tabs_sync_login_client_kRhFGKtR9K from "/app/plugins/tabs-sync-login.client.ts";
import tabs_sync_logout_client_wkgvTW45tG from "/app/plugins/tabs-sync-logout.client.ts";
import token_background_refresh_client_VuibnKGV7u from "/app/plugins/token-background-refresh.client.ts";
import tokenExpiryMonitor_client_KhQQboIIaW from "/app/plugins/tokenExpiryMonitor.client.ts";
import tokenMonitor_client_8NJQxX61hx from "/app/plugins/tokenMonitor.client.ts";
import version_logger_client_twvmINhilP from "/app/plugins/version-logger.client.ts";
import sentry_client_VdOeuw25Mb from "/app/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  api_token_bridge_client_jGF4DmBOdm,
  safe_area_init_client_QbI51lgnxB,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  restore_state_client_4oHW6JzpOW,
  chunk_reload_client_UciE0i6zes,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_config_o34nk2sJbg,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  plugin_8SbxDRbG6Y,
  components_client_ZB1W0EeH0E,
  slideovers_X7whXyrIWR,
  modals_oqljskDzoR,
  colors_ETtiVmZNmO,
  plugin_client_OVoKJro5pc,
  plugin_WLsn00x1qh,
  _00_consola_level_3CPy7oOpos,
  institution_ssr_af4mkUzYu2,
  analytics_client_mtqVw3YRXk,
  yandex_metrika_client_MiNHrQhx1f,
  marketing_consent_sync_client_RIKEnW3W1z,
  dev_unregister_stale_sw_client_mmEH7DCRd7,
  apexcharts_client_Dd5Ebxj7XB,
  app_update_check_client_g6RjdrySyU,
  appearance_client_0OZbkuw8Ky,
  authMonitor_client_ovA28D70BA,
  capacitor_debug_client_9YsBul9OJo,
  capawesome_update_check_client_ZkIndBIwXa,
  cart_migration_client_JUjvYfjpD3,
  debugTools_client_WuVt9iWWnH,
  deep_link_client_BddS0l8Itc,
  max_webapp_client_RA7MVAWi7C,
  push_notifications_auth_init_client_0vmCY4EbxI,
  push_notifications_ios_client_8t7IWUWdTL,
  push_notifications_client_9sl3USyx58,
  queued_notification_action_bridge_client_jkpNBEhTzJ,
  referral_token_client_OhXOx2Kolr,
  rustore_update_init_client_Ywypl0pXrI,
  status_bar_client_VjO5ZxXl7f,
  system_back_handler_client_VDjvzyLqHp,
  tabs_sync_login_client_kRhFGKtR9K,
  tabs_sync_logout_client_wkgvTW45tG,
  token_background_refresh_client_VuibnKGV7u,
  tokenExpiryMonitor_client_KhQQboIIaW,
  tokenMonitor_client_8NJQxX61hx,
  version_logger_client_twvmINhilP,
  sentry_client_VdOeuw25Mb
]